import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a414b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "uf-staff-selector__inner" }
const _hoisted_4 = {
  key: 0,
  style: {"margin-right":"10px"}
}
const _hoisted_5 = {
  key: 2,
  class: "uf-staff-selector__inner-avatar2"
}
const _hoisted_6 = { class: "uf-staff-selector__info" }
const _hoisted_7 = { class: "uf-staff-selector__info-name" }
const _hoisted_8 = { class: "uf-staff-selector__info-other" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createBlock(_component_van_list, {
    loading: _ctx.state.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.loading) = $event)),
    finished: _ctx.state.finished,
    "finished-text": "没有更多了",
    onLoad: _ctx.onLoad
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id
        }, [
          (item.lists.length !== 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "uf-choose-person__title",
                onClick: ($event: any) => (_ctx.onClickTitle(item.id))
              }, [
                _createTextVNode(_toDisplayString(item.stores_name) + " ", 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_van_icon, {
                    name: _ctx.state.customerChecked.includes(item.id) ? 'arrow-down' : 'arrow',
                    size: "18",
                    color: "#999"
                  }, null, 8, ["name"])
                ])
              ], 8, _hoisted_1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.lists, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "uf-staff-selector",
                key: user.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["uf-staff-selector__item", {
              'uf-staff-selector__item--active': _ctx.checkedIdList.includes(user.id)
            }]),
                  onClick: ($event: any) => (_ctx.onClick(user))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.multiple)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _withDirectives(_createVNode(_component_van_icon, {
                            name: "circle",
                            color: "#CCCCCC"
                          }, null, 512), [
                            [_vShow, !_ctx.checkedIdList.includes(user.id)]
                          ]),
                          _withDirectives(_createVNode(_component_van_icon, {
                            name: "checked",
                            color: "#3d6eeb "
                          }, null, 512), [
                            [_vShow, _ctx.checkedIdList.includes(user.id)]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (user.head_pic)
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 1,
                          round: "",
                          width: "40px",
                          height: "40px",
                          src: user.head_pic,
                          class: "uf-staff-selector__inner-avatar"
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (!user.head_pic)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(user.name[0]), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(user.name), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(user.department_name) + " - " + _toDisplayString(user.duty_name), 1)
                    ])
                  ])
                ], 10, _hoisted_2)
              ]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.state.customerChecked.includes(item.id)]
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"]))
}